import { organisationActionType } from '../../constants'

/**
 * Organisation context (W0): { organisation, membershipId, roles } from
 * GET /organisation/me. `roles` are the 11 organisation roles that gate the
 * Investment / Control workspaces and their actions.
 *
 * Capability wave (3 Oct 2026): `capabilities` — for every §14 capability,
 * { label, grade, view, act, test } as the API's own gates decide them. Read
 * through src/hooks/useCapabilities.js.
 */
const initialState = {
  organisation: null,
  membershipId: null,
  roles: [],
  capabilities: {},
  loaded: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case organisationActionType.FETCH_ORGANISATION_ME:
      return {
        organisation: action.payload?.organisation || null,
        membershipId: action.payload?.membershipId || null,
        roles: action.payload?.roles || [],
        capabilities: action.payload?.capabilities || {},
        loaded: true
      }
    // The first read failed: no roles and no capability map, which leaves every screen as it
    // was before the capability wave (the API still refuses what it must). A later read that
    // fails keeps the context already held.
    case organisationActionType.FETCH_ORGANISATION_ME_FAILED:
      return state.loaded ? state : { ...initialState, loaded: true }
    default:
      return state
  }
}
